import { render, staticRenderFns } from "./BargainDialog.vue?vue&type=template&id=8de66e5c&scoped=true"
import script from "./BargainDialog.vue?vue&type=script&lang=js"
export * from "./BargainDialog.vue?vue&type=script&lang=js"
import style0 from "./BargainDialog.vue?vue&type=style&index=0&id=8de66e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de66e5c",
  null
  
)

export default component.exports